import React from 'react';

import { ia } from 'lib/helpers/utility';

import DocText from 'components/shared/DocumentSheet/DocText';
import DocFieldGrid from 'components/shared/DocumentSheet/components/DocFieldGrid';
import { DOC_GAPS, DOC_TEXT } from 'components/shared/DocumentSheet/lib/docStyles';
import DocSectionHead from 'components/shared/DocumentSheet/components/DocSectionHead';

import UpcomingTable from '../components/UpcomingTable/UpcomingTable';
import ReceiptSummary from '../components/ReceiptSummary/ReceiptSummary';
import PaymentHistory from '../components/PaymentHistory/PaymentHistory';
import PaymentSummary from '../components/PaymentSummary/PaymentSummary';

export const buildReceiptBlocks = ({
  receipt,
  practice,
  patient,
  transaction,
  transactions,
  detailEntries,
  itemsBlock,
  historyTransactions,
  walkout,
  walkoutTransactions,
  canSeeAmounts,
  isPatient,
  timezone,
  closing
}) => {
  const summaryTransactions = ia(transactions) ? transactions : [transaction];
  const hasHistory = historyTransactions.some((item) => item?.id);

  return [
    detailEntries.some((entry) => entry?.value) && {
      key: 'details',
      node: (
        <div className={DOC_GAPS.section}>
          <DocSectionHead title="Payment details" />
          <DocFieldGrid entries={detailEntries} />
        </div>
      )
    },
    itemsBlock,
    {
      key: 'totals',
      node: (
        <ReceiptSummary
          isPatient={isPatient}
          transaction={transaction}
          unallocatedAmount={receipt?.unallocatedAmount}
          transactions={summaryTransactions}
          walkout={walkout}
          walkoutTransactions={walkoutTransactions}
        />
      )
    },
    {
      key: 'payment',
      node: (
        <PaymentSummary
          transaction={transaction}
          transactions={summaryTransactions}
          isPatient={isPatient}
          timezone={timezone}
        />
      )
    },
    {
      key: 'columns',
      node: (
        <div className={`${DOC_GAPS.sectionTight} grid grid-cols-2 gap-x-6`}>
          {[
            canSeeAmounts && hasHistory ? (
              <PaymentHistory
                key="history"
                transactions={historyTransactions}
                timezone={timezone}
              />
            ) : null,
            <UpcomingTable
              key="upcoming"
              patientId={transaction?.patient_id || patient?.id}
              practiceId={practice?.id}
              timezone={timezone}
            />
          ]
            .filter(Boolean)
            .map((column) => (
              <div key={column.key} className="min-w-0">
                {column}
              </div>
            ))}
        </div>
      )
    },
    {
      key: 'closing',
      node: (
        <DocText size="xs" className={`${DOC_TEXT.closing} ${DOC_GAPS.closing}`}>
          {closing}
        </DocText>
      )
    }
  ].filter(Boolean);
};
